import React from 'react';
import { Layout } from '@eb/eds-layout';
import {
    CoreApplicationContext,
    CoreGoogleAnalyticsSettings,
} from '@eb/context-gen';
import { SiteStructure } from '@eb/site-structure';
import { trackAnalyticsEvent } from '@eb/site-analytics';

import { Header } from './components/Header';
import { Main } from './components/Main';
import {
    GA_ACTION_PROFILE_DROPDOWN,
    GA_CATEGORY_HEADER,
    GA_LABEL_CREATOR_EVENT,
} from './constants';

import { OrganizerContext, EnvContext, UserProvider } from './context';
import { Organizer, DiscoveryEventsFromView } from './types';

interface ViewData {
    website: string;
    page: {
        background_color: string;
        text_color: string;
    };
    events: DiscoveryEventsFromView;
}

export interface AppProps {
    api_data: {
        organizer: Organizer;
    };
    view_data: ViewData;
    facebookOptions: {
        appId: string;
        version: string;
        xfbml: boolean;
    };
    captchaKeyV2: string;
    featureFlags?: object;
    hasPermissionToEditOrganizationInfo: boolean;
}

export const App: React.SFC<
    CoreApplicationContext & AppProps & CoreGoogleAnalyticsSettings
> = (props) => {
    const headerProps = {
        organizer: props.api_data.organizer,
        website: props.view_data.website,
        customStyle: {
            text_color: props.view_data.page.text_color,
            background_color: props.view_data.page.background_color,
        },
        hasPermissionToEditOrganizationInfo:
            props.hasPermissionToEditOrganizationInfo,
    };

    const mainProps = {
        organizer: props.api_data.organizer,
        events: props.view_data.events,
    };
    const onTrackingUserDropdown = () => {
        trackAnalyticsEvent({
            action: GA_ACTION_PROFILE_DROPDOWN,
            category: GA_CATEGORY_HEADER,
            label: GA_LABEL_CREATOR_EVENT,
        });
    };

    return (
        <SiteStructure
            env={props.env}
            request={props.request}
            user={props.user}
            footerLinks={props.footerLinks}
            fullScreenMain={true}
            featureFlags={props.featureFlags}
            onMouseEnterGlobalHeader={onTrackingUserDropdown}
        >
            <UserProvider user={props.user}>
                <OrganizerContext.Provider value={props.api_data.organizer}>
                    <EnvContext.Provider
                        value={{
                            gaSettings: props.gaSettings,
                            env: props.env,
                            facebookOptions: props.facebookOptions,
                            captchaKey: props.captchaKeyV2,
                        }}
                    >
                        <Layout maxWidth="large" hasHorizontalGutters={true}>
                            <Header {...headerProps} />
                            <Main {...mainProps} />
                        </Layout>
                    </EnvContext.Provider>
                </OrganizerContext.Provider>
            </UserProvider>
        </SiteStructure>
    );
};
